export enum ImportComplementOrigin {
  Default = 'domain.enums.complement_origin.default',
  Cilia = 'domain.enums.complement_origin.cilia',
  Soma = 'domain.enums.complement_origin.soma',
  I360 = 'domain.enums.complement_origin.i360',
  AudatexWeb = 'domain.enums.complement_origin.audatexweb',
  JsonImport = 'domain.enums.complement_origin.jsonImport',
  VisualManagement = 'domain.enums.complement_origin.visualManagement',
  Diagnostic = 'domain.enums.complement_origin.diagnostic',
  Checklist = 'domain.enums.complement_origin.checklist',
  ChecklistExpress = 'domain.enums.complement_origin.checklistExpress',
}
